import { motion } from 'framer-motion'
import SectionTitle from '../ui/SectionTitle'
import StatBadge    from '../ui/StatBadge'

const STATS = [
  { number: '500+', label: 'Parties'       },
  { number: '5',    label: 'Years'         },
  { number: '100%', label: 'Happy Clients' },
]

export default function OurStory() {
  return (
    <section className="section-padding bg-surface">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* ── Left: illustration ────────────────────────────────────────── */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative flex justify-center"
          >
            <div className="relative w-full max-w-sm aspect-square">
              {/* Decorative background */}
              <div className="absolute inset-0 rounded-3xl bg-gradient-card" />

              {/* Image */}
              <img
                src="/assets/mouse-story.png"
                alt="Farafeero mascot with children, balloons, and gifts"
                className="relative z-10 w-full h-full object-contain drop-shadow-xl"
                onError={(e) => {
                  e.currentTarget.style.display = 'none'
                  e.currentTarget.nextElementSibling.style.display = 'flex'
                }}
              />
              {/* Fallback */}
              <div
                className="hidden relative z-10 w-full h-full rounded-3xl bg-gradient-card items-center justify-center"
                aria-hidden="true"
              >
                <p className="text-7xl">🐭🎈🎁</p>
              </div>
            </div>
          </motion.div>

          {/* ── Right: text + stats ───────────────────────────────────────── */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <SectionTitle
              eyebrow="Our Journey"
              title="Our Story ✨"
              centered={false}
            />

            <div className="space-y-4 font-body text-ink-muted text-[1.0625rem] leading-relaxed">
              <p>
                Farafeero World was born from a simple belief: every child deserves a magical
                birthday celebration. We started with a passion for creating joy and have grown
                into a trusted name in children's event planning.
              </p>
              <p>
                Our team of dedicated professionals brings creativity, energy, and attention to
                detail to every event. We handle everything from decoration to entertainment, so
                parents can simply enjoy watching their child's happiness.
              </p>
              <p>
                With over 500+ successful parties and countless smiles created, we continue our
                mission to make every birthday an unforgettable magical experience.
              </p>
            </div>

            {/* Inline stats */}
            <div className="flex flex-wrap gap-8 mt-10 pt-8 border-t border-primary-100">
              {STATS.map(({ number, label }) => (
                <StatBadge key={label} number={number} label={label} />
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
